import makeStyles from '@mui/styles/makeStyles';

const usePlantDetailsContentStyles = makeStyles({
  root: {}
});

export default usePlantDetailsContentStyles;
